// predictive-search-native.js
class NativePredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.getAttribute('section-id');
    this.form = this.closest('form');
    this.input = this.form ? this.form.querySelector('input[type="search"]') : null;

    this.results = this.querySelector('[slot="results"]');
    this.loading = this.querySelector('[slot="loading"]');

    this.abortController = null;
    this.onInput = this.onInput.bind(this);
  }

  connectedCallback() {
    if (!this.input) return;

    // Esconde o skeleton por defeito
    if (this.loading) {
      this.loading.classList.add('hidden');
    }

    this.input.addEventListener('input', this.onInput);
  }

  disconnectedCallback() {
    if (this.input) {
      this.input.removeEventListener('input', this.onInput);
    }
  }

  onInput(event) {
    const term = event.target.value.trim();

    if (!term.length) {
      // Sem texto → limpa resultados e skeleton
      if (this.results) this.results.innerHTML = '';
      if (this.loading) this.loading.classList.add('hidden');
      return;
    }

    this.getResults(term);
  }

  getResults(term) {
    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    const params = new URLSearchParams({
      q: term,
      "resources[type]": "product,collection,article,page,query",
      "resources[limit]": "10",
      section_id: this.sectionId,
    });

    const url = `/search/suggest?${params.toString()}`;

    if (this.loading) {
      this.loading.classList.remove('hidden');
    }

    fetch(url, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newResults = doc.querySelector(
          `predictive-search[section-id="${this.sectionId}"] [slot="results"]`
        );

        if (!newResults || !this.results) return;

        // Substitui o conteúdo do slot de resultados pelo HTML devolvido
        this.results.innerHTML = newResults.innerHTML;
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error('[PredictiveSearch] Error:', error);
      })
      .finally(() => {
        if (this.loading) {
          this.loading.classList.add('hidden');
        }
      });
  }
}

// Regista o custom element
if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', NativePredictiveSearch);
}
